// extracted by mini-css-extract-plugin
export default {"brandCard":"BrandCard_brandCard__DRV35"};